// http://www.devign.me/asynchronous-waiting-for-javascript-procedures
// $waitUntil
// waits until a certain function returns true and then executes a code. checks the function periodically
// parameters
// check - a function that should return false or true
// onComplete - a function to execute when the check function returns true
// delay - time in milliseconds, specifies the time period between each check. default value is 100
// timeout - time in milliseconds, specifies how long to wait and check the check function before giving up
// onTimeout - a function to execute if we reach timeout status

export default function waitUntil() {
  let check;
  let onComplete;
  let delay;
  let timeout;
  let onTimeout;

  // allow for the first argument to be an named argument object
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (args[0] !== null && typeof args[0] === 'object' && Array.isArray(args[0]) === false) {
    ({
      check,
      onComplete,
      delay = 100,
      timeout,
      onTimeout
    } = args[0]);
  } else {
    [check, onComplete, delay, timeout, onTimeout] = args;
  }

  // if the check returns true, execute onComplete immediately
  if (check()) {
    onComplete();
    return;
  }
  if (!delay) delay = 100;
  let timeoutPointer;
  const intervalPointer = setInterval(() => {
    if (!check()) return; // if check didn't return true, means we need another check in the next interval

    // if the check returned true, means we're done here. clear the interval and the timeout and execute onComplete
    clearInterval(intervalPointer);
    if (timeoutPointer) clearTimeout(timeoutPointer);
    onComplete();
  }, delay);
  // if after timeout milliseconds function doesn't return true, abort
  if (timeout) {
    timeoutPointer = setTimeout(() => {
      clearInterval(intervalPointer);
      if (onTimeout) {
        onTimeout();
      }
    }, timeout);
  }
}